import { Link } from 'react-router-dom';

import { Alert } from '../../components/Alert';
import { paths } from '../../routes/paths';

import styles from './AppPages.module.css';

export function UnauthorizedPage(): React.JSX.Element {
  return (
    <div className={styles.page}>
      <header className={styles.pageHeader}>
        <h1 className={styles.pageTitle}>You do not have access to this page</h1>
      </header>

      <Alert tone="warning" title="Permission required">
        Your account is signed in, but it does not hold the permission this screen needs. If you
        believe that is wrong, ask an administrator to review your roles.
      </Alert>

      <p>
        <Link to={paths.dashboard}>Return to the overview</Link>
      </p>
    </div>
  );
}
